<template>
  <div class="adv-group">
    <div v-for="(item,index) in detail" v-if="item.times[0] < curTime && curTime < item.times[1]" :key="index"
      class="item">
      <template v-if="item.link">

        <a :href="item.link" target="_blank">
          <el-image :src="aliUrl + item.url" fit="cover"></el-image>
          <!-- 			<div class="title">
						{{item.title}}
					</div> -->
        </a>
      </template>
      <template v-else>
        <el-image :src="aliUrl + item.url"></el-image>
      </template>
    </div>
  </div>
</template>

<script>
  import {
    aliUrl
  } from '@/utils/app'
  export default {
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        aliUrl: aliUrl,
        curTime: new Date().getTime(),
        detail: {}
      }
    },
    mounted() {
      this.detail = this.$advs[this.id] ? this.$advs[this.id].content : {}
    }
  }
</script>